// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"Fi","centerLink":"Gi","productSection":"Hi","item":"Ii","ctaButton":"Ji"};